import React, { Fragment } from 'react'
import classNames from 'classnames'
import { type CrossClientQueryResultCellProps } from './types'
import { useAppSelector } from '../../../../store/hooks'
import { selectCrossClientResultsExecution, selectCrossClientSelectedTab } from '../../../../store/crossClient/crossClientResults'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'
import { getCrossClientNextStep } from '../crossClientNextStep'

export const CrossClientNextStepCell: React.FC<CrossClientQueryResultCellProps> = ({ result }) => {
  const execution = useAppSelector(selectCrossClientResultsExecution)
  const selectedTab = useAppSelector(selectCrossClientSelectedTab)

  const nextStep = getCrossClientNextStep(selectedTab, result, execution)
  const lastIndex = nextStep.breadcrumb.length - 1

  return (
    <div className='d-flex align-items-center gap-1 flex-wrap zocks-py-0.75'>
      {nextStep.breadcrumb.map((segment, index) => (
        <Fragment key={segment}>
          {index > 0 ? <span className='paragraph-small zocks-text-gray-500'>→</span> : null}
          <span className={classNames('paragraph-small', index === lastIndex ? 'medium zocks-text-gray-900' : 'zocks-text-gray-600')}>{segment}</span>
        </Fragment>
      ))}
      <Tooltip placement='top' title={nextStep.tooltip}>
        <i className='bi bi-info-circle zocks-text-gray-500 cross-client-next-step-info' />
      </Tooltip>
    </div>
  )
}
